/* eslint-disable quote-props */
import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  getTagList: async ({ commit }, payload) => {
    try {
      const res = await axios.get('/tag', {
        params: payload
      })

      commit('SET_STATE', {
        action: 'tags',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.FilteredCount
      })
      return {
        data: res.data.data,
        filteredCount: res.data.FilteredCount,
        total: res.data.totalCount
      }
    } catch (error) {
      const { message } = getMessageFromError(error)
      return Promise.reject(message)
    }
  },

  addNewTag: async (_, payload) => {
    try {
      const res = await axios.post('/tag', payload)

      return {
        data: res.data.supplier,
        message: res.data.message
      }
    } catch (error) {
      const { message } = getMessageFromError(error)
      return Promise.reject(message)
    }
  }
}
